// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8cb97c0d","239":"0f64c368","453":"879e4037","732":"ff15d350"}[chunkId] + ".chunk.js";
};